<form [formGroup]="pfMetaForm" (ngSubmit)="doCall()">
  <mat-form-field style="width: 100%" appearance="outline">
    <mat-label>Provider</mat-label>
    <mat-select formControlName="provider">
      <mat-option *ngFor="let provider of providers" [value]="provider.id">
        {{ provider.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div fxLayout="row" fxLayoutGap=".5rem" fxLayoutAlign="flex-end">
    <button mat-button type="button" (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="pfMetaForm.invalid" type="submit">Send Now</button>
  </div>
  <mat-progress-bar class="emr-dialog-loader" *ngIf="isLoading$ | async" mode="indeterminate"> </mat-progress-bar>
</form>
